import { withRouter } from "react-router";
import { compose } from "recompose";
import qs from "web/core/utils/queryString";
import React, { useMemo } from "react";
import debounce from "lodash/debounce";
import withGenderFilter from "theme/components/helpers/withGenderFilter";

const EnhanceLayeredNavigation = () => {
  const WithOnChange = ({ BaseComponent, ...props }) => {
    const { location, history, genders, currentGender, setGender } = props;

    const onChange = useMemo(
      () =>
        debounce((filter) => {
          let filterPush = filter;
          if (filter?.gender) {
            let genderValue = filter.gender[0];
            if (!currentGender) {
              setGender(genderValue);
            }
            genderValue =
              genders?.find(
                (gender) => Number(genderValue) === Number(gender.code)
              )?.label ?? genderValue;

            filterPush = { genre: genderValue };
          }
          const { pathname, search } = location;
          const filters = { ...qs.parse(search), ...filterPush };
          const updatedSearch = qs.stringify(filters);
          // This is needed so that no additional history.push are performed
          // when a modal route is rendered
          if (search.slice(1) !== updatedSearch) {
            history.push({
              pathname,
              search: updatedSearch,
            });
          }
        }, 200),
      [location, history, genders, currentGender, setGender]
    );

    return <BaseComponent {...props} onChange={onChange} />;
  };

  return compose(withRouter, withGenderFilter(), (BaseComponent) => (props) => (
    <WithOnChange BaseComponent={BaseComponent} {...props} />
  ));
};
export default EnhanceLayeredNavigation;
